module.exports = [
  "backend.config",
  "timesheetMiddleware",
  "DS",
  function(backend, timesheetMiddleware, DS) {
    var timesheet = DS.defineResource({
      name: "timesheets",
      idAttribute: "weekNumber",
      omit: [/^[$]/],
      beforeInject: function(defn, data) {
        timesheetMiddleware(data);
        return data;
      }
    });
    timesheet.find.before(function(id, opts) {
      opts = opts || {};
      opts.endpoint =
        opts.endpointOverride ||
        "timesheets/" + backend.enterprise.code + "/" + backend.userdata.email;
      return [id, opts];
    });
    timesheet.update.before(function(id, data, opts) {
      opts = opts || {};
      opts.method = "POST";
      opts.endpoint =
        opts.endpointOverride ||
        "timesheets/" + backend.enterprise.code + "/" + backend.userdata.email;
      if (opts.path) {
        opts.url =
          (opts.basePath || timesheet.basePath) +
          opts.endpoint +
          "/" +
          id +
          "/" +
          opts.path;
      }
      return [id, data, opts];
    });

    function getTimesheets(start, end) {
      return Promise.resolve().then(function() {
        var requests = [];
        for (var idx = start; idx < end; idx++) {
          requests.push(timesheet.find(idx.toString()));
        }
        return Promise.all(requests);
      });
    }

    return {
      $resource: timesheet,

      get: function(id, opts) {
        return timesheet.get(id, opts);
      },

      getTimesheets: function(startWeek) {
        var config =
          DS.definitions.enterprisePlatformConfig.get(
            backend.enterprise.code
          ) || {};

        var previousWeeks = config.previousTimesheetSummaries || 2;
        if (startWeek && parseInt(startWeek) !== 0) {
          startWeek = Math.max(
            startWeek,
            moment()
              .subtract(104, "weeks")
              .format("YYYYWW")
          );
        } else {
          startWeek = moment()
            .subtract(previousWeeks, "weeks")
            .format("YYYYWW");
        }
        var start = parseInt(startWeek);

        var futureWeeks = parseInt(config.futureTimesheetSummaries) || 4;
        var end = start + futureWeeks;

        return getTimesheets(start, end);
      },

      getMoreTimesheets: function() {
        var config = DS.definitions.enterprisePlatformConfig.get(
          backend.enterprise.code
        );

        var oldestTimesheet = timesheet.getAll().sort(function(a, b) {
          if (a.weekNumber > b.weekNumber) {
            return 1;
          } else if (a.weekNumber < b.weekNumber) {
            return -1;
          } else {
            return 0;
          }
        })[0];
        if (!oldestTimesheet) {
          throw Error("No timesheets loaded");
        }

        var end = parseInt(oldestTimesheet.weekNumber) - 1;
        var start =
          end -
          (config.previousTimesheetSummaries || 2) -
          (config.futureTimesheetSummaries || 4);

        return getTimesheets(start, end);
      },

      getTimesheet: function(data) {
        return timesheet.find(data.weekNumber.toString(), {
          // attrs: data
        });
      },

      postTimesheet: function(data, verb) {
        if (verb === "save") {
          return timesheet.update(data.weekNumber, angular.copy(data), {
            strategy: "single",
            adapter: "http"
          });
        } else if (verb === "submit" || verb === "recall") {
          return timesheet.update(data.weekNumber, angular.copy(data), {
            strategy: "single",
            adapter: "http",
            path: verb
          });
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject("Not Implemented");
        }
      }
    };
  }
];



// WEBPACK FOOTER //
// ./src/api/js-data/api/timesheet.js